import { MerchantEmailConfigSchema } from "@redotech/redo-merchant-email-common/merchant-email-config";
import { MerchantEmailCampaignStatus } from "@redotech/redo-merchant-email-common/merchant-email-trigger";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const updateMerchantEmailStatus = {
  name: "updateMerchantEmailStatus" as const,
  input: z.object({
    id: z.string(),
    status: createEnum(MerchantEmailCampaignStatus),
  }),
  output: MerchantEmailConfigSchema,
};
